import { BadgeProps } from "ui/components/Badge/types";

export type ListingStatusCode = "active" | "paused" | "unpublished";

export interface ListingStatus {
  code: ListingStatusCode;
  /** Naziv koji vidi korisnik — isti u filtru, tablici, karticama i na detalju. */
  label: string;
  description: string;
  variant: NonNullable<BadgeProps["variant"]>;
  /** Boja točkice za mjesta koja ne koriste Badge (legenda, tooltip, traka uz sliku). */
  dotClassName: string;
  /** Boja teksta na tamnoj podlozi (tooltip). */
  textClassName: string;
  /** Boja trake uz sliku u tablici. Klase su ispisane doslovno jer ih Tailwind traži u kodu. */
  barClassName: string;
}

// Jedini izvor naziva i boja statusa oglasa — prije su se razilazili po ekranima
// ("Pauzirano" u tablici, "Pauzirani" u filtru).
export const LISTING_STATUSES: ListingStatus[] = [
  {
    code: "active",
    label: "Aktivan oglas",
    description: "Oglas vidljiv kupcima na barem jednom oglasniku.",
    variant: "success",
    dotClassName: "bg-green-500",
    textClassName: "text-green-400",
    barClassName: "after:bg-green-500",
  },
  {
    code: "paused",
    label: "Pauzirani oglas",
    description: "Oglas postoji ali niti jedan kanal nije aktivan.",
    variant: "warning",
    dotClassName: "bg-amber-400",
    textClassName: "text-amber-400",
    barClassName: "after:bg-amber-400",
  },
  {
    code: "unpublished",
    label: "Bez oglasa",
    description: "Vozilo još nema oglas — kandidat za prvi oglas.",
    variant: "secondary",
    dotClassName: "bg-slate-400",
    textClassName: "text-slate-400",
    barClassName: "after:bg-slate-400",
  },
];

export const getListingStatusByCode = (code: ListingStatusCode): ListingStatus =>
  LISTING_STATUSES.find((s) => s.code === code) as ListingStatus;

/** Status se izvodi iz istog pravila svugdje: ima li vozilo oglas i je li ijedan kanal aktivan. */
export const getListingStatus = (hasListing: boolean, hasActiveChannel: boolean): ListingStatus => {
  if (hasActiveChannel) return getListingStatusByCode("active");
  if (hasListing) return getListingStatusByCode("paused");
  return getListingStatusByCode("unpublished");
};
